<template>
  <div class="upload_box">
    <el-upload
      class="upload-demo upload_apply"
      v-if = "filestype === 'files'"
      action="http"
      :show-file-list = "false"
      :limit = "5"
      :http-request = "fileUploadHttp"
      :on-exceed = "exceedFiles"
      >
      <el-button size="small" type="primary">点击上传</el-button>
      <div slot="tip" class="el-upload__tip">文件大小不超过300M，最多上传5个文件</div>
    </el-upload>
    <!-- 文章发布上传列表 -->
    <el-table
      v-if = "filestype === 'files'"
      :data="list"
      style="width: 50%">
      <el-table-column
        prop="name"
        label="文件名称"
        min-width="200">
      </el-table-column>
      <el-table-column
        label="上传进度"
        width="150">
        <template slot-scope="scope">
          <!-- <el-progress :percentage="scope.row.progress" :format="format"></el-progress> -->
          <div v-show="scope.row.state === '上传中'"><i class="el-icon-loading" style="clolr: #d7b76d"></i> 正在上传</div>
          <div v-show="scope.row.state === '上传成功'">上传成功</div>
          <div v-show="scope.row.state === '上传失败'" style="clolr: #a30d0d">上传成功</div>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-popconfirm v-show="scope.row.state === '上传中'"
          title="是否确定取消文件上传？"
          @onConfirm="cancleFile(scope.$index, scope.row)">
            <el-button size="mini" slot="reference">取消上传</el-button>
          </el-popconfirm>
          <el-popconfirm v-show="scope.row.state === '上传成功'"
          title="是否确定删除该文件？"
          @onConfirm="delFile(scope.$index, scope.row)">
            <el-button size="mini" slot="reference">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import axios from 'axios'
const CancelToken = axios.CancelToken
export default {
  name: 'fileUpload',
  props: {
    filestype: { // 文件类型
      type: String,
      required: true
    },
    articleFileList: {
      type: Array
    }
  },
  data () {
    return {
      list: [],
      fileList: [],
      newFile: null
    }
  },
  created () {
    console.log('复制')
    this.tokens = this.$store.state.user.info.authorization // 用户token获取赋值
    for (let i = 0; i < this.articleFileList.length; i++) {
      this.list.push(this.articleFileList[i])
      this.fileList.push(this.articleFileList[i])
    }
  },
  methods: {
    // 进度条控制
    format (percentage) {
      return percentage === 100 ? '上传成功' : `${percentage}%`
    },
    // 文件上传
    async fileUploadHttp (files) {
      console.log(files)
      const vueThat = this
      vueThat.newFiles = files.file
      vueThat.newFiles.state = '上传中'
      vueThat.newFiles.cancel = null
      let onOff = true
      if (vueThat.list.length > 0) {
        for (let i = 0; i < vueThat.list.length; i++) {
          if (vueThat.list[i].name === vueThat.newFiles.name) {
            onOff = false
            vueThat.$message({
              showClose: true,
              message: '上传文件重复，请修改后重新上传',
              type: 'error'
            })
            break
          }
        }
      }
      if (onOff) {
        vueThat.$emit('btnonoff', false)
        vueThat.list.push(vueThat.newFiles)
        const config = {
          cancelToken: new CancelToken(function executor (c) {
            // executor 函数接收一个 cancel 函数作为参数
            vueThat.newFiles.cancel = c
          })
        }
        const formData = new FormData()
        formData.append('file', files.file)
        console.log(formData)
        await vueThat.myApi.fileUpload(formData, config.cancelToken).then((res) => {
          console.log(res)
          if (res.data.code === 200) {
            for (let i = 0; i < vueThat.list.length; i++) {
              if (vueThat.list[i].name === res.data.data.name) {
                const obj = {}
                obj.name = res.data.data.name
                obj.path = res.data.data.url
                obj.state = '上传成功'
                console.log(vueThat.list)
                vueThat.list.splice(i, 1, obj)
                console.log(obj)
                vueThat.fileList.push(obj)
                console.log(vueThat.fileList)
                vueThat.$emit('files', vueThat.fileList)
                // vueThat.newFiles = null
                break
              }
            }
          } else {
            for (let i = 0; i < vueThat.list.length; i++) {
              if (vueThat.list[i].name === res.data.data.name) {
                vueThat.list[i].path = res.data.data.url
                vueThat.list[i].state = '上传失败'
              }
            }
          }
        }).catch(() => {
        })
      }
    },
    // 取消文件上传
    cancleFile (index, row) {
      row.cancel('取消上传')
      this.list.splice(index, 1)
    },
    // 删除文件
    delFile (index, row) {
      const vueThat = this
      vueThat.myApi.delFile({ url: row.path }).then((res) => {
        if (res.data.code === 200) {
          vueThat.$message({
            showClose: true,
            message: '文件删除成功',
            type: 'success'
          })
          this.list.splice(index, 1)
          for (let i = 0; i < this.fileList.length; i++) {
            if (this.fileList[i].name === row.name) {
              this.fileList.splice(i, 1)
              this.$emit('files', this.fileList)
            }
          }
        }
      })
    },
    exceedFiles (files, fileList) {
      this.$message({
        message: '最多只能上传5个附件',
        type: 'error'
      })
    }
  }
}
</script>

<style scoped="scoped">
.head_img_upload .avatar-uploader-icon{
  height: 100px;
  line-height: 100px;
}
.head_img_upload .avatar-uploader-icon{
  width: 88px;
  font-size: 16px;
}
.upload_box .avatar.head_img{
  width: 88px;
  height: 100px;
}
.upload-demo.upload_apply{
  width: 30%;
}
</style>
